import {
  emailValidation,
  nameValidation,
  phoneValidation,
} from '@percihealth/core-js';
import { InferType, object } from 'yup';

export const ReferralPatientSchema = object().shape({
  firstName: nameValidation.required('Patient first name is required'),
  lastName: nameValidation.required('Patient surname is required'),
  email: emailValidation.required('Patient email is required'),
  phone: phoneValidation,
});

export type ReferralPatient = InferType<typeof ReferralPatientSchema>;
